import { DecimalField } from '@ff-it/form';
import { required } from 'utilities';

type PressFormatFormProps = {
  name?: string;
  /**
   * Geometry is nullable — a vendor that publishes no millimetres states none. Dimensions are only
   * required where the whole format is being entered on its own, as in the row dialog.
   */
  required?: boolean;
};

export function PressFormatForm({ name = '', required: isRequired = true }: PressFormatFormProps) {
  const validate = isRequired ? required : undefined;
  return (
    <div className="form-row">
      <DecimalField
        name={`${name}width_mm`}
        label="Width (mm)"
        className="col-md-4"
        required={isRequired}
        validate={validate}
      />
      <DecimalField
        name={`${name}height_mm`}
        label="Height (mm)"
        className="col-md-4"
        required={isRequired}
        validate={validate}
      />
      <DecimalField name={`${name}bleed_mm`} label="Bleed (mm)" className="col-md-4" help="Per edge" />
    </div>
  );
}
